// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"54894efd","93":"31d6cfe0","174":"a2eab8c1","260":"ee6da3b6","837":"792a61c5"}[chunkId] + ".chunk.css";
};